<template>
  <div class="chip_container" :class="[size, variant]">
    <component :is="icon" v-if="icon" />
    <div class="div_session_color" v-if="variant === 'session'" />
    <img :src="image" v-if="image" alt="Chip icon" height="14" width="14" />
    <label
      class="t-white medium-m white-space-no font-family-2"
      :class="textClass"
      >{{ text }}</label
    >
  </div>
</template>

<script>
import OfflineIcon from '../icons/OfflineIcon.vue';
export default {
  data() {
    return {};
  },

  props: {
    size: {
      type: String,
      default: "small",
    },
    variant: {
      type: String,
      default: "primary",
    },

    text: {
      type: String,
      default: "",
    },
    icon: {
      default: null,
    },
    image: {
      type: String,
      default: "",
    },
    textClass: {
      type: String,
      default: "",
    },
  },
  components: {
    OfflineIcon,
  },
};
</script>
